import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../lib/supabase';

export const useRealtimeStatusCounts = () => {
  const [statusCounts, setStatusCounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isLive, setIsLive] = useState(false);
  const [lastUpdate, setLastUpdate] = useState(null);

  const statuses = [
    { status: 'recepcionado', label: 'Recepcionado' },
    { status: 'inspeccionado', label: 'Inspeccionado' },
    { status: 'cotizando', label: 'Cotizando' },
    { status: 'aprobado', label: 'Aprobado' },
    { status: 'enproceso', label: 'En Proceso' },
    { status: 'terminado', label: 'Terminado' },
    { status: 'entregado', label: 'Entregado' },
    { status: 'cancelado', label: 'Cancelado' }
  ];

  const fetchStatusCounts = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const counts = await Promise.all(
        statuses?.map(async ({ status, label }) => {
          const { count, error: countError } = await supabase
            ?.from('work_orders')
            ?.select('*', { count: 'exact', head: true })
            ?.eq('estado_ot', status);

          if (countError) {
            console.error(`Error counting ${status}:`, countError);
            return { status, label, count: 0 };
          }

          return { status, label, count: count || 0 };
        })
      );

      setStatusCounts(counts);
      setLastUpdate(new Date());
    } catch (err) {
      console.error('Error fetching status counts:', err);
      setError(err?.message || 'Error al cargar contadores');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchStatusCounts();

    const channel = supabase
      ?.channel('status_counts_changes')
      ?.on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'work_orders'
        },
        (payload) => {
          console.log('Status change detected:', payload);
          setIsLive(true);
          fetchStatusCounts();
          
          setTimeout(() => setIsLive(false), 2000);
        }
      )
      ?.subscribe();

    return () => {
      supabase?.removeChannel(channel);
    };
  }, [fetchStatusCounts]);

  return {
    statusCounts,
    loading,
    error,
    isLive,
    lastUpdate,
    refetch: fetchStatusCounts
  };
};